<template>
  <b-row class="form-row catlog-search" vertical-align="center">
    <b-col
      md="8"
      class="pr-0"
      :class="
        showButtonText == 'View Catalog' || hideButtonText == 'Hide Catalog'
          ? 'col-md-8 col-lg-8'
          : 'col-md-9 col-lg-9'
      "
    >
      <b-input-group size="md" class="box-shadow">
        <b-input-group-text slot="prepend" class="search-icon">
          <font-awesome-icon
            :icon="['fas', !scanStatus ? 'search' : 'barcode']"
          />
        </b-input-group-text>
        <b-form-input
          id="product-search"
          v-model.trim="barcode"
          :placeholder="placeholder"
          @keyup.enter="api"
          @keyup.esc="cancelSearch"
          class="search"
          autocomplete="off"
          @keyup="productSearch"
          v-shortkey.focus="['ctrl', 's']"
          :disabled="$loading || searchDisabled"
          @click="(responseList = ''), (totalSearchedProd = 0)"
          autofocus
          ref="search"
        />
        <!-- <b-input-group-text slot="append" v-if="isScan"> -->
        <!-- <a href="#" v-on:click="isShow = !isShow">
            <img data-v-097e74e4 src="/img/barcode.e933a51a.svg" alt class="icon-light" />
          </a>
          <a href="#" v-on:click="isShow = !isShow">
            <img data-v-097e74e4 src="../assets/images/Scan.svg" alt class="icon-dark" />
          </a>-->
        <!-- &nbsp; | &nbsp; -->
        <!-- <a href="#" v-on:click="isShow = !isShow">
            <img
              data-v-097e74e4
              src="../assets/images/kboard.svg"
              alt
              height="20px"
              class="icon-light"
            />
          </a>-->
        <!-- <a href="#" v-on:click="isShow = !isShow">
            <img
              data-v-097e74e4
              src="../assets/images/kboard_ffffff.svg"
              alt
              height="20px"
              class="icon-dark"
            />
          </a>-->

        <!-- <a href="#" v-on:click="isShow = !isShow">
            <img data-v-097e74e4 src="/img/barcode.e933a51a.svg" alt />
          </a>-->
        <!-- <a href="#" v-on:click="isShow = !isShow">
            <img data-v-097e74e4 src="../assets/images/kboard.svg" alt height="20px" />
          </a>-->
        <!-- </b-input-group-text> -->
        <b-input-group-text slot="append">
          <div>
            <small class="mr-2" :style="scanOnlyStyle">Scan Only</small>
            <toggle-button
              :width="24"
              :height="16"
              :labels="false"
              :value="state.system.scan_only_mode"
              @change="toggleScanMode"
              :sync="true"
              color="#4da5e6"
              class="my-auto"
            />
          </div>
        </b-input-group-text>
      </b-input-group>

      <!-- 
      <b-input-group size="md" class="box-shadow">
        <b-input-group-text slot="prepend" class="search-icon"></b-input-group-text>
        <b-form-input v-model="barcode" :placeholder="placeholder" v-on:keyup.enter="addToCart"></b-form-input>
        <b-input-group-text slot="append">
          <a href="#" v-on:click="isShow = !isShow">
            <img data-v-097e74e4 src="../assets/images/Scan.svg" alt />
          </a>
        </b-input-group-text>
      </b-input-group>-->

      <!-- <b-input-group size="md" class="box-shadow scan">
        <b-form-input v-model="barcode" :placeholder="placeholder" v-on:keyup.enter="addToCart"></b-form-input>
        <b-input-group-text
          v-on:click="isShow = !isShow"
          slot="append"
          v-show="!isShow"
          class="scan"
          style="background-color: #4fb0ad"
        >
          <a href="#">
            <img data-v-097e74e4 src="../assets/images/Scan.svg" alt />
          </a>
        </b-input-group-text>
      </b-input-group>-->
      <transition name="slide" v-if="!scanStatus">
        <div class="product-search" v-show="isHide">
          <div class="box-shadow">
            <!-- <ul v-if="responseList.data != ''" id="product-list">
              <li
                v-for="item in responseList.data"
                :key="item.index"
                class="get-product"
                v-shortkey="{
                  up: ['arrowup'],
                  down: ['arrowdown'],
                  enter: ['enter']
                }"
                @shortkey="upDownSearch"
            >-->
            <ul v-if="responseList != ''" id="product-list">
              <li
                v-for="item in responseList"
                :key="item.index"
                class="get-product"
                v-shortkey="{
                  up: ['arrowup'],
                  down: ['arrowdown'],
                  enter: ['enter'],
                }"
                @shortkey="upDownSearch"
              >
                <b-row>
                  <b-col class="w-15">
                    <img src="../assets/images/zwing_default.png" alt />
                  </b-col>
                  <b-col class="w-50">
                    <b-row>
                      <p class="m-0" v-text="item.brand" />
                    </b-row>
                    <b-row>
                      <h6 v-text="item.name" />
                    </b-row>
                  </b-col>
                  <b-col
                    class="w-25"
                    v-text="currencySymbol + formatAmount(item.mrp)"
                  />
                  <b-col class="w-25">
                    <b-button
                      style="padding-top:5px; padding-bottom:5px"
                      variant="info"
                      class="alternative"
                      :id="item.barcode"
                      @click="checkMultipleMrp(item)"
                      :disabled="$loading"
                    >
                      Add
                    </b-button>
                  </b-col>
                </b-row>
              </li>
              <li v-show="totalSearchedProd > limit && barcode.length >= 3">
                <!-- <li> -->
                <b-row
                  class="w-100"
                  @click="(openLoadMoreModal = true), cancelSearch('load-more')"
                >
                  <b-col class="load-more">
                    <h6>Load More</h6>
                  </b-col>
                </b-row>
              </li>
            </ul>
            <div
              class="row align-items-center notification"
              style="height: 100%"
              v-else
            >
              <!-- <div class="spinner" v-show="spinner">loading..</div>-->
              <p class="text-center w-100 my-2">No product found.</p>
            </div>
          </div>
        </div>
      </transition>
    </b-col>
    <b-col lg="3" md="3">
      <b-button
        v-shortkey.once="['ctrl', 'g']"
        :title="btnDisabled == false ? 'ctrl+g' : ''"
        @shortkey="toggleShortkey()"
        block
        variant="primary"
        @click="toggle"
        v-on:click="isShow = !isShow"
        v-show="isShow"
        :disabled="btnDisabled"
        id="view-catalog"
        v-text="showButtonText"
        style="padding:0.610rem 1rem"
      />
      <b-button
        variant="danger"
        block
        @click="toggle"
        v-show="!isShow"
        v-on:click="isShow = !isShow"
        :disabled="btnDisabled"
        id="hide-catalog"
        style="padding:0.610rem 1rem"
        v-text="hideButtonText"
      />
    </b-col>
    <b-col
      md="1"
      class="pl-0"
      v-if="
        showButtonText == 'View Catalog' || hideButtonText == 'Hide Catalog'
      "
    >
      <b-button
        class="w-100"
        @click="refreshCatalog"
        title="Refresh Catalog (ctrl+alt+r)"
        :disabled="btnDisabled"
        v-shortkey="['ctrl', 'alt', 'r']"
        @shortkey="refreshCatalog"
        style="padding:0.61rem 1rem !important"
        :class="state.system.isOffline ? 'disable' : null"
        id="refresh-catalog"
      >
        <font-awesome-icon :icon="['fas', 'redo']" />
      </b-button>
    </b-col>
    <update-qty-modal
      :open="openBox"
      :data="productDetails"
      @close-modal="boxClose"
      :pluQty="pluQty"
      :toCart="true"
    />
    <multiple-mrp-modal
      :multipleMrp="multipleMrp"
      :prod="prodDet"
      @close-multiple="closeMrp"
      :pluQty="pluQty"
      @clear-plu-qty="pluQty = ''"
    />
    <catalog-progress-modal
      :catalogProg="catalogProg"
      @updateHide="updateStatus"
    />
    <batch-serial-modal
      :open="openBatchSerial"
      :batchSerialData="batchSerialData"
      @closeBatchSerialModal="closeBatchSerial"
      @clear-plu-qty="pluQty = ''"
      :pluQty="pluQty"
    />
    <show-search-products
      :open="openLoadMoreModal"
      :search="searchLoadMore"
      :totalProd="totalSearchedProd"
      :limit="limit"
      @close-load-more-modal="
        (openLoadMoreModal = false),
          (searchLoadMore = ''),
          (totalSearchedProd = 0)
      "
      @add-to-cart-more="addRequestHandler"
    />
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import UpdateQtyModal from "./UpdateQtyModal";
import multipleMrpModal from "./multipleMrpModal";
import * as msg from "../message";
import CatalogProgressModal from "./CatalogProgressModal";
import db from "../database";
import BatchSerialModal from "./BatchSerialModal";
import * as helper from "../helper";
import _ from "lodash";
import ShowSearchProducts from "./ShowSearchProducts";

export default {
  name: "catalog-search",
  // props: ["ShowButtonText", "HideButtonText", "placeholder"],
  props: {
    showButtonText: {
      type: String,
      required: true,
    },
    hideButtonText: {
      type: String,
      required: true,
    },
    // placeholder: {
    //   type: String,
    // },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
    searchDisabled: {
      type: Boolean,
    },
    // search: {
    //   type: String
    // },
    isScan: { default: false, type: Boolean },
    isSearch: { default: false, type: Boolean },
  },
  data() {
    return {
      barcode: "",
      isShow: true,
      openBox: false,
      responseList: "",
      isHide: false,
      isContentShow: false,
      productDetails: "",
      counting: 0,
      counteee: 0,
      multipleMrp: false,
      prodDet: "",
      catalogProg: false,
      openBatchSerial: false,
      batchSerialData: {},
      pluQty: "",
      apiRequest: false,
      openLoadMoreModal: false,
      searchLoadMore: "",
      totalSearchedProd: 0,
      limit: 7,
    };
  },
  components: {
    UpdateQtyModal,
    multipleMrpModal,
    CatalogProgressModal,
    BatchSerialModal,
    ShowSearchProducts,
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    globalLoading() {
      return this.state.sessions.syncLoading;
    },
    scanStatus() {
      return this.state.system.scan_only_mode;
    },
    placeholder() {
      let temp = "Search by name or barcode";
      if (this.scanStatus) temp = "Scan barcode to add";
      return temp;
    },
    scanOnlyStyle() {
      let temp = null;
      if (this.state.system.scan_only_mode) temp = { color: "#000" };
      return temp;
    },
  },
  watch: {
    barcode() {
      this.$emit("value", this.barcode);
      if (this.isSearch) {
        if (this.barcode != "") {
          this.isHide = true;
        } else {
          this.isHide = false;
        }
      }
    },
    responseList() {
      if (this.responseList == "") {
        this.counting = 0;
        this.counteee = 0;
        this.totalSearchedProd = 0;
      } else {
        var resplist = Array.from(
          document.getElementsByClassName("get-product")
        );
        for (let i = 0; i < resplist.length; i++) {
          resplist[i].classList.remove("border-prod");
          resplist[i].removeAttribute("id");
        }
      }
    },
    globalLoading(old) {
      if (!old) {
        this.$loading = false;
      }
    },
    $loading() {
      if (!this.$loading) {
        this.$nextTick(() => {
          document.getElementById("product-search").focus();
        });
      }
    },
  },
  methods: {
    toggleScanMode() {
      this.$store.commit(
        "system/setScanOnlyMode",
        !this.state.system.scan_only_mode
      );
      document.getElementById("product-search").focus();
    },
    api() {
      // console.log(`search - ${this.apiRequest}`);
      if (!this.apiRequest) {
        this.apiRequest = true;
        this.checkMultipleMrp("search");
      }
    },
    checkMultipleMrp(type) {
      if (this.barcode == "") {
        this.apiRequest = false;
        return;
      }
      if (
        this.state.system.plu_data.status &&
        _.includes(this.barcode, this.state.system.plu_data.delimiter)
      ) {
        let data = _.split(this.barcode, this.state.system.plu_data.delimiter);
        this.barcode =
          this.state.system.plu_data.format == "suffix" ? data[0] : data[1];
        this.pluQty =
          this.state.system.plu_data.format == "suffix" ? data[1] : data[0];
        // if (this.state.system.plu_data.unit == "gm") {
        //   this.pluQty = (this.pluQty / 1000).toFixed(2);
        // }
      }
      let pdata = type;
      db.transaction("rw", db.products, async () => {
        if (!type.hasOwnProperty("barcode") && this.barcode != "") {
          let search = new RegExp(this.barcode.toLowerCase());

          if (this.state.system.scan_only_mode)
            await db.products
              .where("barcode")
              .equalsIgnoreCase(this.barcode)
              .first((product) => (pdata = product));
          else
            await db.products
              .filter((filter) => {
                return (
                  search.test(filter.barcode.toLowerCase()) ||
                  search.test(filter.name.toLowerCase())
                );
              })
              .first((product) => (pdata = product));
        }
      }).then(() => {
        if (
          pdata != undefined &&
          pdata.is_batch == 1 &&
          pdata.batch.length > 0
        ) {
          this.batchSerialData.type = "Batch";
          this.batchSerialData.batchList = pdata.batch;
          this.batchSerialData.pdata = pdata;
          this.openBatchSerial = true;
          this.apiRequest = false;
          this.clearSearch();
        } else if (
          pdata != undefined &&
          pdata.is_serial == 1 &&
          pdata.serial.length > 0
        ) {
          this.batchSerialData.type = "Serial";
          this.batchSerialData.batchList = pdata.serial;
          this.batchSerialData.pdata = pdata;
          this.openBatchSerial = true;
          this.apiRequest = false;
          this.clearSearch();
        } else if (pdata != undefined && pdata.multiple_price.length > 1) {
          this.prodDet = pdata;
          this.multipleMrp = true;
          this.apiRequest = false;
          this.clearSearch();
        } else {
          if (type != "search") {
            pdata = type;
          }
          if (
            pdata != undefined &&
            pdata != "search" &&
            pdata.hasOwnProperty("barcode")
          ) {
            this.checkProductInCart(pdata);
          } else {
            this.addToCart();
          }
        }
      });
    },
    closeBatchSerial() {
      this.openBatchSerial = false;
      this.$refs["search"].focus();
    },
    checkProductInCart(pdata) {
      if (pdata.weight_flag || pdata.weight) {
        this.addToCartFromSearch(pdata);
      } else {
        let existsItem = this.state.billing.billing.cart.data.filter((item) => {
          return item.product_data.barcode == pdata.barcode;
        });
        if (existsItem.length == 0) {
          this.addToCartFromSearch(pdata);
        } else {
          console.log(
            existsItem[0].product_data.barcode + " " + existsItem[0].qty
          );
          if (
            parseInt(existsItem[0].qty) ==
            parseInt(this.state.system.settings.cart.product_max_qty)
          ) {
            console.log("max qty reached");
            let alertData = {
              message: msg.MAX_PRODUCT_QTY,
              type: "danger",
            };
            this.$store.commit("notifications/showAlert", alertData);
            this.$showAlert = true;
          } else {
            this.addToCartFromSearch(pdata);
          }
        }
      }
    },
    // checkProductInCart(pdata) {
    //   if (pdata.weight_flag == true || pdata.weight == "WEIGHT") {
    //     this.addToCartFromSearch(pdata);
    //   } else {
    //     if (this.state.billing.billing.cart != "") {
    //       var info = true;
    //       let count = 1;
    //       if (this.state.billing.billing.cart.data.length != 0) {
    //         this.state.billing.billing.cart.data.map(item => {
    //           if (item.product_data.barcode == pdata.barcode) {
    //             console.log("[Update Qty]");
    //             if (
    //               parseInt(item.qty) ==
    //               parseInt(this.state.billing.billing.cart.product_max_qty)
    //             ) {
    //               let alertData = {
    //                 message: msg.MAX_PRODUCT_QTY,
    //                 type: "danger"
    //               };
    //               this.$store.commit("notifications/showAlert", alertData);
    //               this.$showAlert = true;
    //             } else {
    //               var value = parseInt(item.qty) + 1;
    //               var prodData = item.product_data;
    //               this.updateToCart(pdata, value, prodData);
    //             }
    //             info = false;
    //           } else if (
    //             info == true &&
    //             count == this.state.billing.billing.cart.data.length
    //           ) {
    //             // console.log(
    //             //   "count: " +
    //             //     count +
    //             //     " cart len: " +
    //             //     this.state.billing.billing.cart.data.length
    //             // );
    //             this.addToCartFromSearch(pdata);
    //           }
    //           count += 1;
    //         });
    //       } else {
    //         this.addToCartFromSearch(pdata);
    //       }
    //     } else {
    //       this.addToCartFromSearch(pdata);
    //     }
    //   }
    // },
    // updateToCart(pdata, value, prodData) {
    //   this.barcode = "";
    //   this.$loading = true;
    //   let productData = {
    //     barcode: pdata.barcode,
    //     scan: "TRUE",
    //     url: "product-qty-update",
    //     qty: value,
    //     change_mrp: "",
    //     unit_mrp: prodData.unit_mrp,
    //     r_price: prodData.r_price,
    //     s_price: prodData.s_price,
    //     amount: "",
    //     discount: "",
    //     pdata: ""
    //   };
    //   let data = Object.assign(
    //     productData,
    //     this.essentialsData,
    //     this.customerData
    //   );
    //   this.$store
    //     .dispatch("billing/updateToCart", data)
    //     .then(res => {
    //       this.$store.dispatch("billing/cartDetails").then(() => {
    //         this.$loading = false;
    //         this.$nextTick(() => {
    //           this.$refs["search"].focus();
    //         });
    //       });
    //     })
    //     .catch(err => {
    //       console.log(err.response);
    //       this.$loading = false;
    //       // this.$bvModal.msgBoxOk(err.response.data.message);
    //     });
    // },
    upDownSearch(event) {
      if (this.$loading) return;
      var resplist = Array.from(document.getElementsByClassName("get-product"));
      switch (event.srcKey) {
        case "down":
          {
            if (this.counting != this.responseList.length - 1) {
              if (this.counteee == 0) {
                resplist[0].classList.add("border-prod");
                this.counteee = 1;
              } else {
                this.counting += 1;
                this.traverseList();
              }
            }
          }
          break;
        case "up":
          {
            if (this.counting != 0) {
              this.counting -= 1;
              this.traverseList();
            }
          }
          break;
        case "enter":
          {
            // console.log(`product - ${this.apiRequest}`);
            if (!this.apiRequest) {
              this.apiRequest = true;
              for (var i = 0; i < resplist.length; i++) {
                if (resplist[i].classList.length == 2) {
                  this.checkMultipleMrp(this.responseList[i]);
                }
              }
              // let border = document.getElementsByClassName("border-prod");
              //  else {
              // if (resplist.length == 1 || border.length == 0) {
              // this.checkMultipleMrp(this.responseList[0]);
              // } else {
            }
            // }
            this.responseList = "";
            this.totalSearchedProd = 0;
            // }
          }
          break;
      }
    },
    traverseList() {
      var resplist = Array.from(document.getElementsByClassName("get-product"));
      // if (resplist.length != this.counting) {
      // console.log(resplist);
      if (resplist.length > 0) {
        for (var i = 0; i < resplist.length; i++) {
          // console.log(resplist[i]);
          if (i == this.counting) {
            resplist[i].classList.add("border-prod");
            resplist[i].id = "to-scroll";
          } else {
            resplist[i].classList.remove("border-prod");
            resplist[i].removeAttribute("id");
          }
        }
      }
      if (resplist.length > 6) {
        var parentUL = document.getElementById("product-list");
        var scrolling = document.getElementById("to-scroll").offsetTop;
        parentUL.scrollTop = scrolling;
      }
    },
    onSubmit: function() {
      console.log("Data Submited");
    },
    toggle: async function() {
      if ((await helper.countProducts()) == 0) {
        let alertData = {
          message: msg.EMPTY_CATALOG,
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
        this.isShow = !this.isShow;
      } else this.$emit("show-cat", this.isShow);
    },
    toggleShortkey: async function() {
      if ((await helper.countProducts()) != 0) {
        this.$emit("show-cat", this.isShow);
        if (this.isShow == true) {
          this.isShow = false;
        } else if (this.isShow == false) {
          this.isShow = true;
        }
      } else {
        let alertData = {
          message: msg.EMPTY_CATALOG,
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      }
    },
    getValue(value) {
      this.search = value;
    },
    addToCartFromSearch: function(data) {
      if (data.weight_flag == true || data.weight == "WEIGHT") {
        this.apiRequest = false;
        this.openBox = true;
        if (typeof Android !== "undefined" && Android !== null) {
          let postData = { type: "read_weight", data: "" };
          returnValue(postData);
        }
        let wData = {
          item_name: data.name,
          images: "",
          unit_mrp: data.mrp,
          category: data.category,
          qty: "0",
          decimal_qty: "0",
          barcode: data.barcode,
          cart_id: "",
          cat_id: "",
          weight: true,
          uom: "kg",
          uom_conversion: data.mrp,
        };
        this.productDetails = wData;
        this.barcode = "";
      } else {
        this.barcode = data.barcode;
        this.addToCart(data);
      }
    },
    productSearch: _.debounce(function() {
      if (this.scanStatus || this.barcode == "") return;
      this.counting = 0;
      this.counteee = 0;

      if (
        this.isSearch == true &&
        this.state.system.hasOwnProperty("product_search_is_offline") &&
        this.state.system.product_search_is_offline == 0
      ) {
        let data = Object.assign(
          {
            search_term: this.barcode,
            limit: this.limit,
            url: "/product-search",
            page: 1,
          },
          this.essentialsData
        );

        if (typeof this._source != typeof undefined) {
          this._source.cancel("Operation canceled due to new request.");
        }

        this._source = axios.CancelToken.source();

        axios
          .post(data.url, data, { cancelToken: this._source.token })
          .then((response) => {
            this.responseList = response.data.data.data;
            this.totalSearchedProd = response.data.data.total;
            if (this.responseList.length > 1)
              this.upDownSearch({ srcKey: "down" });
            else if (this.responseList.length == 1) {
              var resplist = Array.from(
                document.getElementsByClassName("get-product")
              );
              resplist[0].classList.add("border-prod");
              this.counteee = 1;
            }
            if (document.getElementById("product-list") != null)
              document.getElementById("product-list").scrollTop = 0;
            // console.log(response);
          })
          .catch((err) => {
            if (axios.isCancel(err)) {
              console.log("request canceled", err);
            }
            this.$loading = false;
          });
      } else if (
        this.isSearch == true &&
        this.state.system.hasOwnProperty("product_search_is_offline") &&
        this.state.system.product_search_is_offline == 1
      ) {
        // if (this.barcode != "") {
        if (!helper.isStringEmpty(this.barcode)) {
          db.transaction("r", db.products, async () => {
            // await db.products
            //   .where("name")
            //   .startsWithIgnoreCase(this.barcode)
            //   .or("barcode")
            //   .startsWithIgnoreCase(this.barcode)
            //   .or("category")
            //   .startsWithIgnoreCase(this.barcode)
            //   .limit(6)
            //   .each(item => {
            //     data.push(item);
            //   });
            // let search = new RegExp(this.barcode.toLowerCase());
            await db.products
              .orderBy("barcode")
              .and((filter) => {
                return (
                  // search.test(filter.category.toLowerCase()) ||
                  // search.test(filter.barcode.toLowerCase()) ||
                  // search.test(filter.name.toLowerCase()) ||
                  filter.barcode
                    .toLowerCase()
                    .indexOf(this.barcode.toString().toLowerCase()) != -1 ||
                  filter.name
                    .toLowerCase()
                    .indexOf(this.barcode.toString().toLowerCase()) != -1 ||
                  (filter.category != null &&
                    filter.category
                      .toLowerCase()
                      .indexOf(this.barcode.toString().toLowerCase()) != -1)
                );
              })
              .toArray()
              .then((item) => {
                this.totalSearchedProd = item.length;
                this.responseList = item.splice(0, this.limit);
              });
            if (this.responseList.length > 1)
              this.upDownSearch({ srcKey: "down" });
            else if (this.responseList.length == 1) {
              var resplist = Array.from(
                document.getElementsByClassName("get-product")
              );
              resplist[0].classList.add("border-prod");
              this.counteee = 1;
            }
            if (document.getElementById("product-list") != null)
              document.getElementById("product-list").scrollTop = 0;
          });
        }
      }
    }, 200),
    weightPopUP() {
      this.$bvModal.show("add-weight");
    },
    addToCart(pdata) {
      if (
        (pdata != undefined &&
          pdata.is_batch == "1" &&
          pdata.batch.length == 0) ||
        (pdata != undefined &&
          pdata.is_serial == "1" &&
          pdata.serial.length == 0)
      ) {
        this.barcode = "";
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", {
          message: pdata.is_batch == 1 ? msg.NO_BATCH : msg.NO_SERIAL,
          type: "danger",
        });
        return;
      }
      if (this.barcode == "") return;
      // this.apiRequest = true;
      this.$loading = true;
      let self = this;
      let productData = {
        barcode: this.barcode,
        scan: "TRUE",
        url: "product-details",
        qty: "",
        change_mrp: "",
        batch_id: "0",
        serial_id: "0",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      if (this.state.system.isOffline) {
        productData = Object.assign({ unit_mrp: pdata.mrp }, productData);
      }
      let data = Object.assign(
        productData,
        this.essentialsData,
        this.customerData
      );
      // console.log(`add to cart - ${this.apiRequest}`);
      this.$store
        .dispatch("billing/addToCart", data)
        .then((res) => {
          this.responseList = [];
          this.totalSearchedProd = 0;
          this.apiRequest = false;
          if (!this.state.system.isOffline && res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
            this.$loading = false;
            // this.$nextTick(() => {
            //   this.$refs["search"].focus();
            // });
          } else
            this.$store.dispatch("billing/cartDetails").then(() => {
              this.$loading = false;
              // this.$nextTick(() => {
              //   this.$refs["search"].focus();
              // });
            });
          self.barcode = "";
        })
        .catch((err) => {
          self.barcode = "";
          this.apiRequest = false;
          this.$loading = false;

          // this.$nextTick(() => {
          //   this.$refs["search"].focus();
          // });

          if (err.hasOwnProperty("status")) {
            if (err.status == "customer_not_tag") {
              let alertData = {
                message: err.response.data.message,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
            }
          } else {
            if (
              err.response != undefined &&
              err.response.data.status == "product_not_found"
            ) {
              let alertData = {
                message: err.response.data.message,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
            }
            if (
              err.response != undefined &&
              err.response.data.status == "fail"
            ) {
              let alertData = {
                message: err.response.data.message,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
            }
          }
        });
    },
    boxClose(data) {
      this.pluQty = "";
      this.openBox = data;
    },
    // refreshCatalog() {
    //   // this.$refs["catalog-progress-modal"].show();
    //   this.catalogProg = true;
    //   this.$loading = true;
    //   var data = {
    //     api_token: this.state.sessions.user.api_token,
    //     // c_id: "",
    //     v_id: this.state.sessions.user.vendor_id,
    //     store_id: this.state.sessions.user.store_id,
    //     vu_id: this.state.sessions.user.vu_id,
    //     trans_from: this.state.system.trans_from,
    //     url: "/vendor/get-catalog"
    //   };
    //   // console.log(data.url);
    //   let postData = Object.assign(
    //     data,
    //     this.essentialsData,
    //     this.customerData
    //   );
    //   axios
    //     .post(data.url, postData)
    //     .then(response => {
    //       this.$store.commit(
    //         "products/offlineItems",
    //         response.data.catalog_data
    //       );
    //       this.$store.dispatch(
    //         "offline/saveOfflineStoreProducts",
    //         response.data.catalog_data
    //       );
    //       this.$loading = false;
    //       // let alertData = {
    //       //   message: msg.REFRESH_CATALOG,
    //       //   type: "success"
    //       // };
    //       // this.$showAlert = true;
    //       // this.$store.commit("showAlert", alertData);
    //     })
    //     .catch(err => {
    //       this.$loading = false;
    //       console.log(err.response);
    //     });
    // },
    refreshCatalog() {
      if (this.state.system.isOffline == false) {
        this.$store.commit("products/clearProgress");
        this.state.sessions.syncLoading = true;
        this.catalogProg = true;
        this.$loading = true;
        this.$store.dispatch("offline/saveOfflineStoreProducts").then(() => {
          // this.catalogProg = false;
          this.$loading = false;
        });
      }
    },
    updateStatus() {
      if (this.catalogProg == true) {
        this.catalogProg = false;
      }
    },
    closeMrp(data) {
      this.multipleMrp = data;
      this.$nextTick(() => {
        this.$refs["search"].focus();
      });
    },
    clearSearch() {
      this.barcode = "";
      this.$nextTick(() => {
        this.$refs["search"].focus();
      });
    },
    cancelSearch(where = "") {
      if (where == "load-more") this.searchLoadMore = this.barcode;
      this.resplist = "";
      this.barcode = "";
      this.$nextTick(() => {
        this.$refs["search"].focus();
      });
    },
    addRequestHandler(data) {
      this.openLoadMoreModal = false;
      this.barcode = data.barcode;
      this.checkMultipleMrp(data);
    },
  },
};
</script>
<style lang="scss" scoped>
.product-search {
  background-color: #fff;
  position: absolute;
  width: 99%;
  z-index: 9;
}
.theme-dark .product-search {
  background-color: #303030;
}
.notification h6 {
  font-weight: 500;
  // disp
}
ul {
  padding: 10px 0px;
  top: -350px;
  height: auto;
  max-height: 350px;
  border-radius: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  overflow-y: auto;
  @include custom-scrollbar();
  margin-bottom: 0px;
}
li {
  width: 100%;
  list-style-type: none;
  padding: 5px 15px;
  border-bottom: 1px #f0f0f0 solid;
  // &:hover {
  //   background-color: #c0c0c0;
  //   color: #fff;
  // }
  &:last-child {
    border-bottom: transparent !important;
  }
  p {
    font-weight: 300;
    font-size: 0.625rem;
  }
  h6 {
    font-weight: 400;
    font-size: 0.825rem;
    margin: 0px;
  }
  .row {
    display: table;

    .col {
      display: table-cell;
      vertical-align: middle;
      color: #000;
    }
  }
}
.theme-dark {
  border-bottom: 1px #c0c0c0 solid;

  li {
    &.get-product {
      border-bottom: 1px #464646 solid !important ;
    }
  }

  .row .col {
    display: table-cell;
    vertical-align: middle;
    color: #c0c0c0;
    .row p {
      color: #c0c0c0;
    }
    h6 {
      color: #c0c0c0;
    }
  }
  .border-prod {
    // border: 1px solid red;
    background-color: #000000;
  }
}
.disable {
  cursor: no-drop;
  opacity: 0.3;
  pointer-events: none;
}
@keyframes slide {
  0% {
    opacity: 0;
    top: 0%;
  }
  100% {
    opacity: 1;
    top: 100%;
    transition-duration: 0.5s;
  }
}
.slide-enter-active {
  animation: slide 0.5s;
  opacity: 1;
}
.slide-leave-active {
  animation: slide 0.5s reverse;
  opacity: 1;
}
.fa-redo {
  transition: 0.5s all ease;
}
.grey-btn:hover {
  .fa-redo {
    transform: rotate(180deg);
    -webkit-transform: (180deg);
    transition: 0.5s all ease;
  }
}
.grey-btn:disabled:hover {
  .fa-redo {
    transform: rotate(0deg);
    -webkit-transform: (0deg);
  }
  opacity: 0.3;
}
.border-prod {
  // border: 1px solid red;
  background-color: #f0f0f0;
}
.key-link {
  color: $dark-grey;
}
.load-more {
  padding: 10px 10px 0px 10px;
  text-align: center;
  cursor: pointer;
}
</style>
